var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4H5C4.72386 4 4.5 4.22386 4.5 4.5V19.5C4.5 19.7761 4.72386 20 5 20H20C20.2761 20 20.5 19.7761 20.5 19.5V13.5H21.5V19.5C21.5 20.3284 20.8284 21 20 21H5C4.17157 21 3.5 20.3284 3.5 19.5V4.5C3.5 3.67157 4.17157 3 5 3H11V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8536 3.35378C19.4868 2.72061 20.5133 2.72062 21.1465 3.35378C21.7797 3.98695 21.7797 5.01351 21.1465 5.64667L13.73 13.0632L12.6623 13.4191L14.0001 12.7502L11.7501 10.5002L11.0812 11.8379L11.4371 10.7703L18.8536 3.35378ZM21.8536 2.64667C20.8299 1.62299 19.1702 1.62298 18.1465 2.64667L10.6465 10.1467L10.563 10.2301L10.5257 10.3421L9.18383 14.3678C8.98839 14.9541 9.54619 15.5119 10.1325 15.3165L14.1582 13.9746L14.2701 13.9372L14.3536 13.8538L21.8536 6.35378C22.8773 5.33009 22.8773 3.67036 21.8536 2.64667Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.d2625a8d24d2a1c72f9b87cac84252c4.svg";
export { ForwardRef as ReactComponent };